var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-wrap cf",attrs:{"id":"modalwrap"}},[_c('div',{staticClass:"modal-header"},[_vm._v("Message")]),_c('div',{staticClass:"modal-content"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }